export default __webpack_public_path__ + "static/media/ships.b7a7ae89.svg";